'use strict';

function LoanLiquidAdditionalPaymentFailed() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this.analytics.pushEvent('virtual-page-view');
  };

  this.destroy = function () {
    delete this.presenter.models.money.loans.loans[0].create_additional;

    this._super();
  };
}